import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DebouncedInput from 'Common/Components/v2/DebouncedInput';
import { setBulkUpdateValue } from 'store/Manage/actions';
import { selectErrorMessage, selectModalBulkUpdateValue } from 'store/Manage/selectors';
import { RESET_ERROR_VALUE } from 'store/Manage/types';

const NameInput = () => {
  const dispatch = useDispatch();
  const bulkUpdateValue = useSelector(selectModalBulkUpdateValue);
  const message = useSelector(selectErrorMessage);
  const onChange = (value) => {
    dispatch(setBulkUpdateValue(value));
    if (message) dispatch({ type: RESET_ERROR_VALUE });
  };

  return (
    <DebouncedInput
      value={ bulkUpdateValue }
      onChange={ onChange }
      name="name"
      title="vulnerability name"
      focusOnMount
      error={ !!message }
      errorMessage={ message }
    />
  );
};

export default NameInput;
